export type MotionToken = "fast" | "base" | "slow";

/**
 * A --motion-* token from motion.css in ms, read live so reduced motion reads 0. 0 when the sheet is absent.
 * The prod CSS minifier writes 200ms as ".2s" (gll33f5b, 10-14): the unit is read, never assumed.
 */
export const motionMs = (token: MotionToken): number => {
  if (typeof window === "undefined") return 0;
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(`--motion-${token}`)
    .trim();
  const n = parseFloat(raw);
  if (!Number.isFinite(n)) return 0;
  return raw.endsWith("ms") ? n : n * 1000;
};

export type EaseToken = "out" | "move";
/** The four numbers of --ease-<name> from motion.css; null when the sheet is absent (jsdom). */
export const motionEase = (
  name: EaseToken,
): [number, number, number, number] | null => {
  if (typeof window === "undefined") return null;
  const raw = getComputedStyle(document.documentElement).getPropertyValue(
    `--ease-${name}`,
  );
  const n = /cubic-bezier\(([^)]*)\)/.exec(raw)?.[1].split(",").map(Number);
  return n?.length === 4 && n.every(Number.isFinite)
    ? (n as [number, number, number, number])
    : null;
};
/** --ease-<name> as an Element.animate easing; "ease-out" without the sheet. One body for useFlip and the morph. */
export const easeCss = (name: EaseToken): string => {
  const n = motionEase(name);
  return n ? `cubic-bezier(${n.join(", ")})` : "ease-out";
};
